import Checkbox from '@mui/material/Checkbox';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setUserSettings as setUserSettingsProps } from '../../_flux/Actions';
import { type FluxStore } from '../../_flux/Store';
import sDashboardElemente from '../../_json/s_dashboardElemente';
import { setUserSettings } from '../../_tools/AxiosVars';
import { setConf } from '../../_tools/Session';
import Toast from '../../_tools/Toast';
import { checkUndefinedNullOrEmpty } from '../../_tools/Tools';
import { getVertrag } from '../../_tools/Vertrag';
import { type UserSettings } from '../../login/EnsureLoggedInContainer';
import { LEAD } from '../../vars';

const EinstellungenDashboard = () => {
    const userSettings = useSelector((state: FluxStore) => state.userSettings);
    const vertrage = useSelector((state: FluxStore) => state.vertrage);
    const dispatch = useDispatch();

    const [output, setOutput] = useState<any>(undefined);

    const switchColumns = (id) => {
        const settings = userSettings;
        const array = settings?.dashboard || [];
        if (array.includes(id)) array.splice(array.indexOf(id), 1);
        else array.push(id);

        const dashboardSettings = array;
        const newUserSettings: UserSettings = {
            ...settings,
            dashboard: dashboardSettings,
        };

        setUserSettings(newUserSettings)
            .then(() => {
                dispatch(setUserSettingsProps(newUserSettings));
                setConf(newUserSettings);
            })
            .catch(() =>
                Toast.addError({ key: 'EinstellungenDashboard_setUserSettings', primary: 'Fehler beim Ändern der Dashboardelemente', secondary: 'Bitte versuchen Sie es in ein paar Sekunden erneut' })
            );
    };

    const renderOutput = () => {
        const columnsExtended = [];
        const settings = userSettings?.dashboard ? userSettings?.dashboard : [];
        const lead = getVertrag('lead', vertrage);
        const elemente = sDashboardElemente(lead, LEAD);
        Object.keys(elemente).forEach((key) => {
            if (!columnsExtended[elemente[key].group]) columnsExtended[elemente[key].group] = [];
            if (!elemente[key].hidden) columnsExtended[elemente[key].group].push({ id: key, n: elemente[key].n });
        });
        columnsExtended.map((row, index) => {
            columnsExtended[index].sort((a, b) => {
                if (a.n < b.n) return -1;
                if (a.n > b.n) return 1;
                return 0;
            });
        });

        const out = [];
        Object.keys(columnsExtended).forEach(function (key) {
            if (!checkUndefinedNullOrEmpty(columnsExtended[key])) {
                out.push(<ListSubheader key={key}>{key}</ListSubheader>);
                for (let i = 0; i < columnsExtended[key].length; i++) {
                    if (!columnsExtended[key][i].hidden) {
                        out.push(
                            <ListItemButton key={key + '_' + i} onClick={() => switchColumns(columnsExtended[key][i].id)}>
                                <ListItemIcon>
                                    <Checkbox checked={settings?.includes(columnsExtended[key][i].id)} />
                                </ListItemIcon>
                                <ListItemText>{columnsExtended[key][i].n}</ListItemText>
                            </ListItemButton>
                        );
                    }
                }
            }
        });
        setOutput(out);
    };

    useEffect(
        function () {
            renderOutput();
        },
        [userSettings]
    );

    return <List style={{ overflow: 'auto', maxHeight: '85vh' }}>{output}</List>;
};

export default EinstellungenDashboard;
